<section>
    <footer>
        <div class="ftr">
            <div class="container-fluid d-none d-lg-block d-xl-block">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row">
                            <div class="col-sm-2">
                                <div class="card">
                                    <div class="card-body text-center">
                                        <img src="../../../assets/img/logo.png" class="img-fluid" alt="Responsive image">
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-2.7">
                                <div class="card">
                                    <div class="card-body">
                                        <h5 class="card-title">AYUDA</h5>
                                        <p class="card-text help" (click)="openHelp('pasos')"><i class="fa fa-chevron-right"></i> Pasos para comprar</p>
                                        <p class="card-text help" (click)="openHelp('formas')"><i class="fa fa-chevron-right"></i> Formas de pago</p>
                                        <p class="card-text help" (click)="openHelp('envios')"><i class="fa fa-chevron-right"></i> Envíos y entregas</p>
                                        <p class="card-text help" (click)="openHelp('cuenta')"><i class="fa fa-chevron-right"></i> Mi cuenta</p>
                                        <p class="card-text help" (click)="openHelp('preguntas')"><i class="fa fa-chevron-right"></i> Preguntas frecuentes</p>
                                        <p class="card-text help" [routerLink]="['/terminos']"><i class="fa fa-chevron-right"></i> Términos y condiciones</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-3.7">
                                <div class="card contacto">
                                    <div class="card-body">
                                        <h5 class="card-title">CONTACTO</h5>
                                        <p class="card-text">
                                            Tienda Online Torreón Market
                                        </p>
                                        <p class="card-text mt-4">
                                            <button class="icn"><i class="fa fa-phone"></i></button>&nbsp; 323 4902185
                                        </p>
                                        <p class="card-text">
                                            <button class="icn"><i class="fa fa-envelope"></i></button>&nbsp;torreonmarket.info@gmail.com
                                        </p>
                                        <p class="card-text">
                                          <button class="icn"><a href="https://api.whatsapp.com/send?phone=+57 323 4902185" target="_blank" style="text-decoration: none;color: #fff;"><i class="fa fa-whatsapp"></i></a></button>&nbsp;whatsapp 323 4902185
                                      </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="card">
                                    <div class="card-body">
                                        <h5 class="card-title mt-3">SÍGUENOS EN:</h5>
                                        <p class="card-text">
                                          <a class="btn btn-light redes mr-1" href="https://www.facebook.com/torreonmarket.colombia" target="blank"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                                          <a class="btn btn-light redes mr-1" href="https://www.youtube.com/channel/UCMhrKPXZXlqmfUKSyXMIlsw" target="blank"><i class="fa fa-youtube" aria-hidden="true"></i></a>
                                          <a class="btn btn-light redes mr-1" href="https://twitter.com/torreonmarket" target="blank"><i class="fa fa-twitter" aria-hidden="true"></i></a>
                                          <a class="btn btn-light redes" href="https://www.instagram.com/torreon.market" target="blank"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                                        </p>
                                        <div>
                                            <h5 class="card-title mt-4">DÉJANOS TU CORREO</h5>
                                            <p class="card-text">No te pierdas las novedades y el contenido para cuidarte a ti y a los que mas amas.</p>
                                            <form class="form-inline" [formGroup]="subscriptionForm" (ngSubmit)="subscription(subscriptionForm.value)">
                                                <input class="form-control susc" type="text" placeholder="Ingresa tu correo" formControlName="email" aria-label="Search">
                                                <button class="btn btn-light btnPer" type="submit">SUSCRÍBETE</button>
                                                <small class="eml" *ngIf="emailNoValido">Ingrese un email válido</small>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container d-xs-block d-sm-block d-md-block d-lg-none d-xl-none">
                <div class="row row-cols-1 row-cols-md-3">
                    <div class="col mb-4">
                        <div class="card">
                            <div class="card-body text-center">
                                <img src="../../../assets/img/logo.png" width="70%" class="img-fluid" alt="Responsive image">
                            </div>
                        </div>
                    </div>
                    <div class="col mb-4">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">AYUDA</h5>
                                <p class="card-text help" (click)="openHelp('pasos')"><i class="fa fa-chevron-right"></i> Pasos para comprar</p>
                                <p class="card-text help" (click)="openHelp('formas')"><i class="fa fa-chevron-right"></i> Formas de pago</p>
                                <p class="card-text help" (click)="openHelp('envios')"><i class="fa fa-chevron-right"></i> Envíos y entregas</p>
                                <p class="card-text help" (click)="openHelp('cuenta')"><i class="fa fa-chevron-right"></i> Mi cuenta</p>
                                <p class="card-text help" (click)="openHelp('preguntas')"><i class="fa fa-chevron-right"></i> Preguntas frecuentes</p>
                                <p class="card-text help" [routerLink]="['/terminos']"><i class="fa fa-chevron-right"></i> Términos y condiciones</p>
                              </div>
                        </div>
                    </div>
                    <div class="col mb-4">
                        <div class="card contacto">
                            <div class="card-body">
                                <h5 class="card-title">CONTACTO</h5>
                                <p class="card-text">
                                    Tienda Online Torreón Market
                                </p>
                                <p class="card-text mt-4">
                                    <button class="icn"><i class="fa fa-phone"></i></button>&nbsp; 323 4902185
                                </p>
                                <p class="card-text" style="font-size: 14px;">
                                    <button class="icn"><i class="fa fa-envelope"></i></button>&nbsp;torreonmarket.info@gmail.com
                                </p>
                                <p class="card-text">
                                    <button class="icn"><a href="https://api.whatsapp.com/send?phone=+57 323 4902185" target="_blank" style="text-decoration: none;color: #fff;"><i class="fa fa-whatsapp"></i></a></button>&nbsp;whatsapp 323 4902185
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col mb-4">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title mt-3">SÍGUENOS EN:</h5>
                                <p class="card-text">
                                  <a class="btn btn-light redes mr-1" href="https://www.facebook.com/torreonmarket.colombia" target="blank"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                                  <a class="btn btn-light redes mr-1" href="https://www.youtube.com/channel/UCMhrKPXZXlqmfUKSyXMIlsw" target="blank"><i class="fa fa-youtube" aria-hidden="true"></i></a>
                                  <a class="btn btn-light redes mr-1" href="https://twitter.com/torreonmarket" target="blank"><i class="fa fa-twitter" aria-hidden="true"></i></a>
                                  <a class="btn btn-light redes" href="https://www.instagram.com/torreon.market" target="blank"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                                </p>
                                <div>
                                    <h5 class="card-title mt-4">DÉJANOS TU CORREO</h5>
                                    <p class="card-text">No te pierdas las novedades y el contenido para cuidarte a ti y a los que mas amas.</p>
                                    <form class="form-inline" [formGroup]="subscriptionForm" (ngSubmit)="subscription(subscriptionForm.value)">
                                        <input class="form-control susc" type="text" placeholder="Ingresa tu correo" formControlName="email" aria-label="Search">
                                        <div class="text-center" style="width: 100%;">
                                            <button class="btn btn-light btnPer mt-2" type="submit">SUSCRÍBETE</button>
                                        </div>
                                        <small class="eml" *ngIf="emailNoValido">Ingrese un email válido</small>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12 ftrr d-none d-lg-block d-xl-block">
                <div class="row">
                    <div class="col-lg-4 mt-3">
                        <p style="font-size: 11px;">
                            Copyright <i class="fa fa-copyright" aria-hidden="true"></i> {{fecha}} Torreón Market - Reservados todos los derechos.
                        </p>
                    </div>
                    <div class="col-lg-4 mt-3 text-center">
                        <p style="font-size: 13px;">
                            Desarrollado por <a href="https://itssoluciones.com/inicioIts/" target="blank">ITS Soluciones</a>
                        </p>
                    </div>
                    <div class="col-lg-4 mt-3">
                        <div class="row" style="justify-content: right; margin-right: 20px;">
                            <p style="font-size: 13px;">
                              <a style="color: black;" href="https://www.sic.gov.co/" target="blank">www.sic.gov.co</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12 ftrr d-xs-block d-sm-block d-md-block d-lg-none d-xl-none">
                <div class="row">
                    <div class="col-lg-12 mt-2 text-center">
                        <p style="font-size: 11px;">
                            Copyright <i class="fa fa-copyright" aria-hidden="true"></i> {{fecha}} Torreón Market - Reservados todos los derechos. Desarrollado por <a href="https://itssoluciones.com/inicioIts/" target="blank">ITS Soluciones </a> - <a style="color: black;" href="https://www.sic.gov.co/" target="blank">www.sic.gov.co</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</section>
